import { z } from "zod";
import { nonEmptyString } from "../zod/nonEmptyString.js";

export const leadParagraphBlockSchema = z.object({
	text: nonEmptyString,
});
